// extracted by mini-css-extract-plugin
module.exports = {"container":"ActivateCardModal_container__2RikQ","activatedContainer":"ActivateCardModal_activatedContainer__s60QF","checkmark":"ActivateCardModal_checkmark__GB8hX"};